module.exports = __webpack_public_path__ + "static/media/navigate-next.de6336c2.svg";